module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputLanguage"
  }, [_c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("Input Language " + _vm._s(_vm.$route.params.name))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])]), _vm._v(" "), (!_vm.language) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.language) ? _c('div', {
    staticClass: "input-language-card mdl-card mdl-shadow--2dp",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, _vm._l((Object.keys(_vm.translationTargets)), function(inputType) {
    return _c('div', {
      staticClass: "translationTarget"
    }, [_c('h4', [_vm._v(_vm._s(inputType))]), _vm._v(" "), _c('h6', [_vm._v("Columns")]), _vm._v(" "), _c('ColumnTranslation', {
      attrs: {
        "targets": _vm.translationTargets[inputType]
      },
      model: {
        value: (_vm.config[inputType].columnTranslation),
        callback: function($$v) {
          _vm.$set(_vm.config[inputType], "columnTranslation", $$v)
        },
        expression: "config[inputType].columnTranslation"
      }
    }), _vm._v(" "), _c('h6', [_vm._v("Summary Lines")]), _vm._v(" "), _c('SummaryRegex', {
      model: {
        value: (_vm.config[inputType].summaryRegex),
        callback: function($$v) {
          _vm.$set(_vm.config[inputType], "summaryRegex", $$v)
        },
        expression: "config[inputType].summaryRegex"
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v("\n          Save\n        ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fb48e82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputLanguage.vue
// module id = 415
// module chunks = 1